import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { emailPasswordLogin, toggleFourFootImagery, selectDashboard } from "../redux/actions";
import { withRouter, Redirect } from "react-router-dom";
import { isMobile } from "react-device-detect";
import MediaQuery from "react-responsive";
import logo from "../images/new-branding-2.0/aivr-purple.svg";
import logoWhite from "../images/new-branding-2.0/aivr-hybrid.svg";
import OBCSpinner from "./util/OBC";
import { MEMOIZED_DOMAIN_URL } from "./util/HostUtils";
import { Button } from "antd";

const JwtToken = (props) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const [requireAuth, setRequireAuth] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(props.location.search);
        const jwtToken = params.get("token");
        if (jwtToken) {
            setLoading(true);
            dispatch(
                emailPasswordLogin(
                    {
                        jwt: jwtToken,
                    },
                    {},
                    isMobile,
                    (response, error, require_auth, jwt_email) => {
                        if (require_auth && jwt_email) {
                            setEmail(jwt_email);
                            setRequireAuth(true);
                        }
                        setLoading(false);
                        if (!response) {
                            setError(error);
                        } else {
                            setSuccess(true);
                        }
                    },
                ),
            );
        } else {
            if (window.location.hostname !== `view-widget${MEMOIZED_DOMAIN_URL}`) {
                setError("This link is invalid or expired");
            } else {
                setError("This session is invalid or expired");
            }
        }
    }, [props.location.search, dispatch]);

    const handleManualLogin = () => {
        setLoading(true);
        dispatch(
            emailPasswordLogin(
                {
                    email: email,
                    password: password,
                    jwt: new URLSearchParams(props.location.search).get("token"),
                },
                {},
                isMobile,
                (response, content) => {
                    const accessToken = content?.access_token;

                    if (!response || !accessToken) {
                        setError(content);
                    } else {
                        setSuccess(true);
                        setRequireAuth(false);
                        dispatch(selectDashboard(accessToken));
                    }
                    setLoading(false);
                },
            ),
        );
    };

    if (!success) {
        return (
            <div className="LoginOverlay Center-Content">
                <div className="LoginContent__Container">
                    <div className="LoginContent">
                        <MediaQuery maxWidth={479}>
                            <img
                                className="LoginLogo mobile"
                                src={logoWhite}
                                alt="AIVR Logo"
                                crossOrigin={"anonymous"}
                            />
                        </MediaQuery>
                        <MediaQuery minWidth={479}>
                            <img
                                className="LoginLogo"
                                src={logo}
                                alt="AIVR Logo"
                                crossOrigin={"anonymous"}
                            />
                        </MediaQuery>

                        {loading && (
                            <OBCSpinner
                                size={100}
                                speed={3}
                                color={"#e8dfff"}
                            />
                        )}

                        {error && (
                            <div>
                                <p className="ErrorText">{error}</p>
                            </div>
                        )}

                        {window.location.hostname !== `view-widget${MEMOIZED_DOMAIN_URL}}` && (
                            <div className="LoginFooter">
                                <div className="LoginSales">
                                    For enquiries, please contact <a href="mailto:support@onebigcircle.co.uk">support@onebigcircle.co.uk</a>.
                                </div>
                                <div className="LoginTerms">
                                    By using this website you agree to our&nbsp;
                                    <p>
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href="/terms">
                                            Terms of Use
                                        </a>{" "}
                                        &{" "}
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href="/privacy">
                                            Privacy Policy
                                        </a>
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    } else {
        if (requireAuth) {
            return (
                <div className="MinLoginContainer">
                    <div className="LoginContent">
                        <div className="MinLoginWrapper">
                            <div className="MingLoginLogoWrapper">
                                <img
                                    src={logo}
                                    alt="AIVR Logo"
                                    crossOrigin={"anonymous"}
                                />
                                <div className="LoginTerms">
                                    By using this website you agree to our&nbsp;
                                    <p>
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href="/terms">
                                            Terms of Use
                                        </a>{" "}
                                        &{" "}
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href="/privacy">
                                            Privacy Policy
                                        </a>
                                    </p>
                                </div>
                            </div>
                            <div className="MinLoginFormWrapper">
                                <input
                                    id="login-email"
                                    align="center"
                                    className="LoginInput"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter your e-mail address"
                                    autoFocus
                                />
                                <input
                                    id="login-password"
                                    align="center"
                                    className="LoginInput"
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Enter your password"
                                />
                                <Button
                                    type={error ? "danger" : "primary"}
                                    onClick={handleManualLogin}
                                    loading={loading}>
                                    Sign in
                                </Button>
                            </div>
                        </div>
                        {error ? <div className="MinLoginError">{error}</div> : null}
                    </div>
                </div>
            );
        }

        let redirect = { pathname: "/" };

        const params = new URLSearchParams(props.location.search);

        if (props.location.state && props.location.state.from) {
            redirect = props.location.state.from;
        } else if (isMobile && !props.requestedDesktop) {
            redirect = { pathname: "/mobile" };
        }
        if (params.get("four_foot") === "true") {
            dispatch(toggleFourFootImagery(true));
        }
        if (params.get("selected")) {
            redirect.search = `selected=${params.get("selected")}`;
        }

        return <Redirect to={redirect} />;
    }
};

export default withRouter(JwtToken);
